type MetadataFromPrismic = {
  title?: string;
  description?: string;
  robot?: string;
  canonicalLink?: string;
};

export const defaultTitle = "The pension for the self-employed";
export const defaultDescription =
  "Penfold is the only pension built specifically for freelancers & contractors. Start with as much as you like or as little as £10. Stop anytime.";
export const defaultRobot = "index, follow";

export type Metadata = {
  title: string;
  robot: string;
  description: string;
  ogTitle: string;
  ogDescription: string;
  twitterTitle: string;
  twitterDescription: string;
  canonicalLink: string;
};
export const formatMetadata = (metadata: MetadataFromPrismic): Metadata => {
  return {
    title: metadata.title || defaultTitle,
    robot: metadata.robot?.split("/")?.join(", ") || defaultRobot,
    description: metadata.description || defaultDescription,
    ogTitle: metadata.title || defaultTitle,
    ogDescription: metadata.description || defaultDescription,
    twitterTitle: metadata.title || defaultTitle,
    twitterDescription: metadata.description || defaultDescription,
    canonicalLink: metadata.canonicalLink,
  };
};
